import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { CalendarTaskCategoryListItem, ICalendarTaskCategoryListItem } from "./calendarTaskCategoryListItem";

export interface ICalendarTaskCategoryListItems extends ListItems<ICalendarTaskCategoryListItem> {
}

export class CalendarTaskCategoryListItems extends ListItems<CalendarTaskCategoryListItem> implements ICalendarTaskCategoryListItems {
    constructor();
    constructor(obj: ICalendarTaskCategoryListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, CalendarTaskCategoryListItem);
    }
}